import { defineMessages } from 'react-intl';

export const creditCardMessages = defineMessages({
    numberLabel: {
        id: 'creditCard.numberLabel',
        description: 'Label for credit card number field on payment form',
        defaultMessage: 'Card Number'
    },
    expiryMonthLabel: {
        id: 'creditCard.expiryMonthLabel',
        description: 'Label for expiration month field on payment form',
        defaultMessage: 'Expiration Month'
    },
    expiryYearLabel: {
        id: 'creditCard.expiryYearLabel',
        description: 'Label for expiration year field on payment form',
        defaultMessage: 'Expiration Year'
    },
    securityCodeLabel: {
        id: 'creditCard.securityCodeLabel',
        description: 'Label for security code (CVV) field on payment form',
        defaultMessage: 'CVV'
    },
    invalidCCNum: {
        id: 'creditCard.invalidCCNum',
        description: 'When invalid or missing credit card',
        defaultMessage: 'Please enter a valid Card Number'
    },
    CCNumRequired: {
        id: 'creditCard.CCNumRequired',
        description: 'When Credit Card Number is empty',
        defaultMessage: 'Card Number is a required field'
    },
    invalidCCType: {
        id: 'creditCard.invalidCCType',
        description: 'When valid number is not accepted type',
        defaultMessage: 'Please use an accepted credit card type'
    },
    invalidCode: {
        id: 'creditCard.invalidCode',
        description: 'When security code is missing or invalid',
        defaultMessage: 'Please enter a valid CVV'
    },
    invalidExpYear: {
        id: 'creditCard.invalidExpYear',
        description: 'When previous year or too far out',
        defaultMessage: 'Please enter a valid Expiration Year'
    },
    ExpYearRequired: {
        id: 'creditCard.ExpYearRequired',
        description: 'When Credit Card Year is empty',
        defaultMessage: 'Expiration Year is a required field'
    },
    invalidExpMonth: {
        id: 'creditCard.invalidExpMonth',
        description: 'When expiration month is not valid',
        defaultMessage: 'Please enter a valid Expiration Month'
    },
    ExpMonthRequired: {
        id: 'creditCard.ExpMonthRequired',
        description: 'When Credit Card Month is empty',
        defaultMessage: 'Expiration Month is a required field'
    },
    expired: {
        id: 'creditCard.expired',
        description: 'Error message when a credit card has expired',
        defaultMessage: 'Your credit card has expired.',
    },
    invalidCvv: {
        id: 'creditCard.invalidCvv',
        description: 'When cvv is not valid',
        defaultMessage: 'Please enter a valid CVV'
    },
    CvvRequired: {
        id: 'creditCard.CvvRequired',
        description: 'When Cvv is empty',
        defaultMessage: 'CVV is a required field'
    },
});
